/**
 * @function ProtectedRoute
 * @description
 * Hard block unauthorized users from access a route
 *
 * @example
 * import { restrictRoute } from 'components/protected-route';
 * import View from './view';
 *
 * export default [
 * restrictRoute({
 *   id: 'route',
 *   name: 'Route Name',
 *   path: 'route',
 *   access: ['PermissionType'],
 *   Component: View
 * }),
 */
import ProtectedRoute from './protected-route';

function restrictRoute(route) {
  return Object.assign({}, route, {
    Component: ProtectedRoute,
    loader: () => ({
      access: route.access || []
    }),
    children: [
      {
        path: '',
        Component: route.Component,
        children: route.children
      }
    ],
  });
}

export { restrictRoute };
export default ProtectedRoute;
